import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type OrderEventFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const OrderEventFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: OrderEventFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-3.333377 -3.333313) scale(1.533329)',
        },
        [
          h(
            'path',
            {
              "fill-rule": 'evenodd',
              "clip-rule": 'evenodd',
              d: 'M6.31253 3.05903C6.31253 2.7503 6.56437 2.50003 6.87503 2.50003H13.125C13.4357 2.50003 13.6875 2.7503 13.6875 3.05903V6.08703H17.0313C17.1616 6.08703 17.2861 6.14096 17.3748 6.23587C17.4635 6.33078 17.5084 6.45811 17.4988 6.58728L16.7175 17.0686C16.6994 17.3118 16.4955 17.5 16.25 17.5H3.75004C3.50459 17.5 3.3007 17.3118 3.28257 17.0686L2.50132 6.58728C2.49169 6.45811 2.53662 6.33078 2.62531 6.23587C2.714 6.14096 2.83845 6.08703 2.96879 6.08703H6.31253V3.05903ZM12.5625 3.61804V6.08703H7.43753V3.61804H12.5625ZM6.87504 11.5995C6.61615 11.5995 6.40629 11.8081 6.40629 12.0654C6.40629 12.3226 6.61615 12.5312 6.87504 12.5312H13.125C13.3839 12.5312 13.5938 12.3226 13.5938 12.0654C13.5938 11.8081 13.3839 11.5995 13.125 11.5995H6.87504Z',
            },
          ),
        ],
      ),
    ],
  );

export default OrderEventFilled;
